<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pb-0">
        <div class="tw-flex tw-justify-between tw-items-center">
          <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-800 tw-mb-0 tw-font-thin">Training</h1>
          <base-button v-if="canManage === true" @click="newTraining()" class="tw-hidden sm:tw-flex">
            <template v-slot:icon>
              <plus-icon />
            </template>
            Add Training
          </base-button>
          <base-icon @click="newTraining()" class="tw-inline sm:tw-hidden">
            <plus-icon class="tw-h-5 tw-w-5" />
          </base-icon>
        </div>
        <base-tabs class="tw-mt-2 tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)" :key="categories.length">
          <base-tab title="All Training" selected />
          <base-tab v-for="category in categories" :key="category" :title="category" />
        </base-tabs>
      </base-content>
    </div>
    <base-content class="tw-grid sm:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-8 tw-mt-3">
      <div class="tw-px-4 sm:tw-px-0" v-for="training in filteredTrainings" :key="training.id" :id="training.id">
        <training-card
          :id="training.id"
          :businessId="businessId"
          :name="training.name"
          :category="training.category"
          :description="training.description"
          :sort-order="training.sortOrder"
          :documentId="training.documentId"
          :document-extension="training.documentExtension"
          :imageDocumentId="training.imageDocumentId"
          :imageExtension="training.imageExtension"
          @refresh="loadTrainings"
        />
      </div>
      <div v-for="i in 3" :key="i">
        <div v-if="isLoading === true">
          <base-card noPadding class="tw-h-full tw-flex tw-flex-col">
            <training-icon stroke-width=".8" class="tw-rounded-t-md tw-border-b-2" :style="{ height: '180px', width: '100%' }" style="object-fit:cover" />
            <base-content class="tw-flex-grow tw-w-full">
              <base-skeleton-loader class="tw-h-5 tw-w-1/2 tw-mb-4" />
              <base-skeleton-loader class="tw-h-3 tw-w-full tw-mb-3" />
              <base-skeleton-loader class="tw-h-3 tw-w-full tw-mb-3" />
              <base-skeleton-loader class="tw-h-3 tw-w-3/4" />
            </base-content>
            <base-content class="tw-pt-0 tw-w-full">
              <div class="tw-flex tw-my-auto">
                <base-skeleton-loader class="tw-h-9 tw-w-full" />
                <base-skeleton-loader class="tw-h-9 tw-w-4 tw-ml-3" />
              </div>
            </base-content>
          </base-card>
        </div>
      </div>
      <new-training ref="newTraining" :businessId="businessId" @saved="loadTrainings()" />
    </base-content>
  </div>
</template>

<script>
import NewTraining from "@/views/business/training/components/NewTraining";
import TrainingCard from "@/views/business/training/components/TrainingCard";
import uniq from "lodash/uniq";
import { mapGetters } from "vuex";
import { PlusIcon, TrainingIcon } from "@/assets/svgs";

export default {
  name: "BusinessTrainingsView",
  components: { NewTraining, TrainingCard, PlusIcon, TrainingIcon },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      trainings: [],
      selectedCategory: null,
      filteredTrainings: [],
      categories: [],
    };
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered", "isBusinessManagement", "isPredictile"]),
    canManage() {
      if ((this.isLocationFiltered === false && this.isBusinessManagement(this.businessId) === true) || this.isPredictile() === true) return true;
      else return false;
    },
  },
  created() {
    this.loadTrainings();
  },
  methods: {
    loadTrainings() {
      this.isLoading = true;

      this.$axios
        .get(`/businesses/${this.businessId}/trainings/list`)
        .then((res) => {
          this.trainings = res.data;
          this.selectedCategory = null;
          this.categories = this.getCategories(res.data);
          this.filteredTrainings = res.data.sort((a, b) => (a.sortOrder || Number.MAX_SAFE_INTEGER) - (b.sortOrder || Number.MAX_SAFE_INTEGER));
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to load training courses",
            message: "We had a problem retrieving the list of training documents. Please reload the page to try again.",
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getCategories(trainings) {
      return trainings ? uniq(trainings.map(({ category }) => category)).sort() : [];
    },
    setFilter(category) {
      if (category) {
        this.filteredTrainings = this.trainings
          .filter((training) => training.category === category)
          .sort((a, b) => (a.sortOrder || Number.MAX_SAFE_INTEGER) - (b.sortOrder || Number.MAX_SAFE_INTEGER));
        this.selectedCategory = category;
      } else {
        this.filteredTrainings = this.trainings.sort((a, b) => (a.sortOrder || Number.MAX_SAFE_INTEGER) - (b.sortOrder || Number.MAX_SAFE_INTEGER));
      }
    },
    tabClick(tabTitle) {
      if (tabTitle === "All Training") {
        this.setFilter(null);
      } else {
        this.setFilter(tabTitle);
      }
    },
    newTraining() {
      this.$refs.newTraining.show();
    },
  },
};
</script>
